import * as yup from 'yup'
import { mediaContainerDesignSchema } from '../media/Media.schema'
import { createPropertiesSchema } from '../schemaUtils'
import { videoBackgroundProperties } from '../media/Video.schema'

export const designSchema = mediaContainerDesignSchema

export const propertiesSchema = createPropertiesSchema(
	'PopupContainerProperties',
	yup
		.object({
			horizontalAlignment: yup.mixed<'left' | 'center' | 'right'>().default('center'),
			verticalAlignment: yup.mixed<'top' | 'center' | 'bottom'>().default('top'),
			alignmentType: yup.mixed<'nineGrid' | 'fullHeight' | 'fullWidth'>().default('nineGrid'),
			horizontalOffset: yup.number().default(0),
			verticalOffset: yup.number().default(0),
		})
		.concat(videoBackgroundProperties)
)
